import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from '@modules/main/main.component';
import { BlankComponent } from '@pages/blank/blank.component';
import { LoginComponent } from '@modules/login/login.component';
import { ProfileComponent } from '@pages/profile/profile.component';
import { RegisterComponent } from '@modules/register/register.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { AuthGuard } from '@guards/auth.guard';
import { NonAuthGuard } from '@guards/non-auth.guard';
import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { SubMenuComponent } from '@pages/main-menu/sub-menu/sub-menu.component';
import { GalleryComponent } from "@pages/gallery/gallery.component";
import { BlogsComponent } from "@pages/blogs/blogs.component";
import { NewsFeedComponent } from "@pages/news-feed/news-feed.component";
import { HomeComponent } from "@modules/home/home.component";
import { PressReleaseComponent } from "@pages/press-release/press-release.component";
import { ClientsComponent } from "@pages/clients/clients.component";
import { StudentComponent } from "@pages/students/student.component";
import { BalanceSheetComponent } from "@pages/balance-sheet/balance-sheet.component";
import { FunctionComponent } from "@pages/function/function.component";
import { LibraryComponent } from "@pages/library/library.component";
import { TestimonialComponent } from '@pages/testimonial/testimonial.component';
import { SocialMediaComponent } from '@pages/social-media/social-media.component';
import { AuditoriumUploadComponent } from '@pages/auditorium-upload/auditorium-upload.component';
import { Component } from '@angular/core';
import { SponsorComponent } from '@pages/sponsor/sponsor.component';
import { VolunteerComponent } from '@pages/volunteer/volunteer.component';
import { DonateComponent } from '@pages/donate/donate.component';
import { ArtistComponent } from '@pages/artist/artist.component';
import { EventsComponent } from '@pages/events/events.component';
import { FeedbackComponent } from '@pages/feedback/feedback.component';
import { BannerImageComponent } from '@pages/banner-image/banner-image.component';
import { ProductionComponent } from '@pages/production/production.component';

const routes: Routes = [
  {
    path: 'main',
    component: MainComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'profile',
        component: ProfileComponent
      },
      {
        path: 'blank',
        component: BlankComponent
      },
      {
        path: 'sub-menu-1',
        component: SubMenuComponent
      },
      {
        path: 'sub-menu-2',
        component: BlankComponent
      },
      {
        path: 'home',
        component: DashboardComponent
      },
      {
        path: 'gallery',
        component: GalleryComponent
      },
      {
        path: 'blogs',
        component: BlogsComponent
      },
      {
        path: 'news-feed',
        component: NewsFeedComponent
      },
      {
        path: 'press-release',
        component: PressReleaseComponent
      },
      {
        path: 'company-partners',
        component: ClientsComponent
      },
      {
        path: 'students',
        component: StudentComponent
      },
      {
        path: 'balance-sheet',
        component: BalanceSheetComponent
      },
      {
        path: 'function',
        component: FunctionComponent
      },
      {
        path: 'library',
        component: LibraryComponent
      },
      {
        path: 'testimonial',
        component: TestimonialComponent
      },
      {
        path: 'social-media',
        component: SocialMediaComponent
      },
      {
        path: 'auditorium',
        component: AuditoriumUploadComponent
      },
      {
        path: 'sponsor',
        component: SponsorComponent
      },
      {
        path: 'volunteer',
        component: VolunteerComponent
      },
      { path: 'volunteer/:id', component: VolunteerComponent },
      {
        path: 'donate',
        component: DonateComponent
      },
      {
        path: 'artist',
        component: ArtistComponent
      },
      {
        path: 'artist/:id',
        component: ArtistComponent
      },
      {
        path: 'events',
        component: EventsComponent
      },
      {
        path: 'banner-image',
        component: BannerImageComponent
      },
      {
        path: 'feedback',
        component: FeedbackComponent
      },
      {
        path: 'production',
        component: ProductionComponent
      },
      {
        path: 'production/:id',
        component: ProductionComponent
      }
    ]
  },
  {
    path: '',
    component: LoginComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'recover-password',
    component: RecoverPasswordComponent,
    canActivate: [NonAuthGuard]
  },
  {
    path: 'home',
    component: HomeComponent
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
